
import { useLanguage } from "@/contexts/LanguageContext";

interface AuthHeaderProps {
  isSignUp: boolean;
  isVerifying: boolean;
}

export const AuthHeader = ({ isSignUp, isVerifying }: AuthHeaderProps) => {
  const { t } = useLanguage();

  return (
    <div className="text-center mb-8">
      <h1 className="text-4xl font-bold tracking-tight text-primary py-1">
        {isVerifying ? t('verifyEmail') || 'Verify Email' : isSignUp ? t('register') : t('login')}
      </h1>
      <div className="w-24 h-1 mx-auto mt-3 bg-gradient-to-r from-primary via-primary/70 to-primary rounded-full"></div>
      <p className="text-sm text-muted-foreground mt-4 max-w-sm mx-auto">
        {isVerifying ? 
          t('verifyEmailDesc') || 'Enter the verification code sent to your email' : 
          isSignUp ? t('createAccountDesc') : t('loginDesc')}
      </p>
    </div>
  );
};
